<template>
  <section id="SectionInvestNow">
    <Wrap class="lg">
      <h3 class="title">
        {{ $t('title') }}
      </h3>

      <p v-for="(paragraph, index) in $ta('paragraphs')" :key="index">
        <Markdown :markdown="paragraph" />
      </p>

      <div class="cta">
        <Route class="Btn" :title="$t('cta')" :to="{ name: $route.name, hash: '#FooterContact' }">
          {{ $t('cta') }}
        </Route>
      </div>
    </Wrap>
  </section>
</template>

<script>
const Markdown = () => import(/* webpackChunkName: 'showdown' */ 'views/components/Markdown')

export default {
  components: { Markdown },
}
</script>

<style lang="scss">
#SectionInvestNow {
  .title {
    margin-bottom: 3rem;
  }

  p {
    margin-bottom: 2rem;
    @include md {
      margin-bottom: 3rem;
    }
  }

  .cta {
    margin-top: 3rem;
    text-align: center;
    @include md {
      margin-top: 4rem;
    }
  }
}
</style>

<i18n>
{
  "lt": {
    "title": "Dabar galite įsigyti saulės elektrinę neinvestuodami didelių sumų savo lėšomis",
    "paragraphs": [
      "Klientams, šiuo metu nenorintiems skirti didelės pradinės investicijos saulės elektrinei įsigyti, paruošėme ypatingą pasiūlymą. Saulės elektrinę siūlome įsigyti išsimokėtinai, **be pradinio mokesčio** ir **tik su 5,5% metinėmis palūkanomis**. Net 10 metų siekiantis išsimokėjimo terminas leis smarkiai sumažinti mėnesines įmokas, o **sumažėjusiomis sąskaitomis už elektrą pradėsite mėgautis iš kart**, gavę APVA paramą!",
      "Birželio 1 dieną startavo naujas APVA paramos etapas, skirtas įsigyti saulės elektrinę išsimokėtinai. Dalinama **padidinta 381 Eur/kW** parama saulės elektrinėms iki 10 kW galios.",
      "Kviečiame nepraleisti šios puikios progos. Susisiekite su mūsų konsultantais jau šiandien ir pasitarkite dėl Jums tinkamiausio sprendimo."
    ],
    "cta": "Gaukite pasiūlymą "
  }
}
</i18n>
